'use client';

import { useEffect, useLayoutEffect } from 'react';
import { usePathname } from 'next/navigation';

const APP_TITLE = 'Implement AI';

export function ViewportHeightFix() {
    const pathname = usePathname();

    useLayoutEffect(() => {
        document.title = APP_TITLE;
    }, [pathname]);

    useEffect(() => {
        const set = () => {
            document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
        };
        set();
        window.addEventListener('resize', set);
        return () => window.removeEventListener('resize', set);
    }, []);
    return null;
}
